(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["benefits-marquee"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('benefit-marquee')) {
    class BenefitMarquee extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('.benefit-marquee__track');
        this.halves = this.querySelectorAll('.benefit-marquee__half');
        if (!this.track || this.halves.length !== 2) return;

        this.resizeObserver = new ResizeObserver(() => this.fit());
        this.resizeObserver.observe(this);
        this.fit();
      }

      disconnectedCallback() {
        this.resizeObserver?.disconnect();
      }

      /* Each half must be at least as wide as the strip, or a gap shows before the loop restarts.
         Add copies to both halves until it is, then derive the duration from the half's width. */
      fit() {
        const [first, second] = this.halves;
        const group = first.querySelector('.benefit-marquee__group');
        if (!group) return;

        let guard = 0;
        while (first.offsetWidth < this.offsetWidth && guard++ < 10) {
          for (const half of this.halves) {
            const copy = group.cloneNode(true);
            copy.classList.add('benefit-marquee__group--copy');
            copy.setAttribute('aria-hidden', 'true');
            half.appendChild(copy);
          }
        }

        const speed = Number(this.dataset.speed) || 27;
        const halfWidth = first.getBoundingClientRect().width;
        if (halfWidth > 0) {
          this.style.setProperty('--benefit-marquee-duration', `${(halfWidth / speed).toFixed(2)}s`);
        }
      }
    }

    customElements.define('benefit-marquee', BenefitMarquee);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
